var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file tab组件
 * @author (zhaojun10)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { classPrefix } from '../../common/util';

import TabNav from './TabNav';
import TabContent from './TabContent';

import './Tab.less';

/**
 * 参数说明
 * classPrefix              可选，自定义class前缀
 * className                可选，自定义类名
 * defaultActiveIndex       必需，默认active
 * activeIndex              可选，active值
 * type                     可选，'normal'、'line'、'underline'，默认'normal'
 * skin                     可选，'blue', 'purple', 默认'blue',
 * onHandleClick            可选，回调传出activeIndex值
 * backgroundColor          必选，背景色，默认#fff,只在type为'normal'、'line'下有效
 */

var Tabs = function (_Component) {
    _inherits(Tabs, _Component);

    function Tabs(props) {
        _classCallCheck(this, Tabs);

        var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

        var currProps = _this.props;
        _this.handleTabClick = _this.handleTabClick.bind(_this);
        var activeIndex = void 0;
        if ('activeIndex' in currProps) {
            activeIndex = currProps.activeIndex;
        } else if ('defaultActiveIndex' in currProps) {
            activeIndex = currProps.defaultActiveIndex;
        }
        _this.state = {
            activeIndex: activeIndex,
            prevIndex: activeIndex
        };
        return _this;
    }

    _createClass(Tabs, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if ('activeIndex' in nextProps) {
                this.setState({
                    activeIndex: nextProps.activeIndex
                });
            }
        }
    }, {
        key: 'handleTabClick',
        value: function handleTabClick(activeIndex) {
            var prevIndex = this.state.activeIndex;
            var callback = this.props.onHandleClick;
            if (this.state.activeIndex !== activeIndex && 'defaultActiveIndex' in this.props) {
                this.setState({
                    activeIndex: activeIndex,
                    prevIndex: prevIndex
                });
            }
            callback && callback(activeIndex);
        }
    }, {
        key: 'renderTabNav',
        value: function renderTabNav() {
            var _props = this.props,
                classPrefix = _props.classPrefix,
                children = _props.children,
                backgroundColor = _props.backgroundColor,
                type = _props.type,
                skin = _props.skin,
                responsive = _props.responsive;


            return React.createElement(TabNav, {
                key: 'tabBar',
                classPrefix: classPrefix,
                onTabClick: this.handleTabClick,
                panels: children,
                activeIndex: this.state.activeIndex,
                backgroundColor: backgroundColor,
                tabType: type,
                skin: skin,
                responsive: responsive
            });
        }
    }, {
        key: 'renderTabContent',
        value: function renderTabContent() {
            var _props2 = this.props,
                classPrefix = _props2.classPrefix,
                children = _props2.children,
                backgroundColor = _props2.backgroundColor,
                skin = _props2.skin;


            return React.createElement(TabContent, {
                key: 'tabcontent',
                classPrefix: classPrefix,
                activeIndex: this.state.activeIndex,
                panels: children,
                backgroundColor: backgroundColor,
                skin: skin
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props3 = this.props,
                classPrefix = _props3.classPrefix,
                className = _props3.className,
                type = _props3.type,
                skin = _props3.skin;

            var cx = classnames((_classnames = {}, _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, classPrefix + '-ui-tab', true), _defineProperty(_classnames, classPrefix + '-ui-tab-line', type === 'line'), _defineProperty(_classnames, classPrefix + '-ui-tab-line-purple', skin === 'purple'), _defineProperty(_classnames, classPrefix + '-ui-tab-underline', type === 'underline'), _defineProperty(_classnames, classPrefix + '-ui-tab-underline-purple', skin === 'purple'), _classnames));
            return React.createElement(
                'div',
                { className: cx },
                this.renderTabNav(),
                this.renderTabContent()
            );
        }
    }]);

    return Tabs;
}(Component);

Tabs.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    defaultActiveIndex: PropTypes.number,
    activeIndex: PropTypes.number,
    type: PropTypes.string,
    skin: PropTypes.string,
    onHandleClick: PropTypes.func,
    backgroundColor: PropTypes.string,
    responsive: PropTypes.bool
};
Tabs.defaultProps = {
    classPrefix: classPrefix,
    backgroundColor: '#fff'
};
export default Tabs;